import { ItemList } from "../../UI/Cube/types";
import homeItems from "./home/items";
import { useEffect, useState } from "react";

export enum PageType {
  HOME,
}

const useCubeItems = (pageType: PageType): ItemList => {
  const [items, setItems] = useState<ItemList>(null);

  useEffect(() => {
    const getItems = async () => {
      if (pageType === PageType.HOME) {
        setItems(homeItems());
      }
    };
    if (!items) {
      getItems();
    }
  }, [pageType, items]);

  return items;
};

export default useCubeItems;
